import Handsontable from 'handsontable/base';
import { getFirstSelection, isSelectingSingleSelection } from '../tableCellSelectionUtils';

/**
 * Adds a formula to the currently selected cell in the Handsontable instance.
 */
export const addHotTableFormulaToCell = (
    hotInstance: Handsontable | null | undefined,
    cellSelections = hotInstance?.getSelected(),
) => {
    if (!hotInstance) return;
    if (!cellSelections) return;

    if (!isSelectingSingleSelection(cellSelections)) return;

    const cellSelection = getFirstSelection(cellSelections);
    if (!cellSelection) return;

    requestAnimationFrame(() => {
        if (!hotInstance || hotInstance.isDestroyed) return;

        // Restore focus to the cell before starting the editor (the toolbar click will have blurred it)
        hotInstance.selectCell(...cellSelection, false, true);

        hotInstance.getActiveEditor()?.beginEditing('=');
    });
};
